export default __webpack_public_path__ + "static/media/alyra_logo.252fb3a5.png";